import { Checkbox, cn, Typography } from "@suraasa/placebo-ui"
import { InfoCircleSolid } from "iconoir-react"
import { RefCallBack } from "react-hook-form"

const AgreementCheckBox = ({
  errorMessage,
  title,
  ref,
  onChange,
  value,
}: {
  errorMessage?: string | undefined
  title: string
  ref: RefCallBack
  onChange: (...event: any[]) => void
  value: any
}) => {
  return (
    <div>
      <Checkbox
        checked={value}
        ref={ref}
        onCheckedChange={onChange}
        containerClass={cn(
          "flex items-center gap-1.5 rounded border border-surface-200 bg-surface-100 px-1.5 py-1",
          { "border-critical-500": errorMessage }
        )}
        label={
          <div>
            <Typography variant="smallBody">{title}</Typography>
          </div>
        }
      />
      {errorMessage && (
        <div className="mt-1 flex items-center gap-0.5 px-1.5">
          <InfoCircleSolid className="size-2 text-critical-500" />

          <Typography className="text-critical-500" variant="smallBody">
            {errorMessage}
          </Typography>
        </div>
      )}
    </div>
  )
}

export default AgreementCheckBox
